import { Injectable, ErrorHandler } from '@angular/core';
import { AppAnalytics } from '../logging/shared/analytics';

@Injectable()
export class AnalyticsErrorHandlerService extends ErrorHandler {
  constructor() {
    super();
  }

  handleError(error: any): void {
    try {
      if (error) {
        AppAnalytics.error(error, AppAnalytics.toProperties(error));
      }
    } catch {
      //reporting must never keep the original error from reaching the default handler
    }

    super.handleError(error);
  }
}
